export const ZIP_CODE_PATTERN = /^\d{5}(?:[-\s]\d{4})?$/;
